import { IColumn, Stack, Text } from '@fluentui/react';
import { AccessGroupRow } from '.';
import { EditAccessGroup } from '../view/EditAccessGroup';
import { AccessGroupItem } from './AccessGroupItem';

export type ColumnStylesProps = {
  onRenderColumnStack: string;
};

export const onRenderItems = (styles: ColumnStylesProps) => {
  const renderItemColumn = (
    item: AccessGroupRow,
    _index: number | undefined,
    column: IColumn | undefined
  ) => {
    if (item) {
      const fieldContent = item[
        column?.fieldName as keyof AccessGroupRow
      ] as string;
      switch (column?.key) {
        case 'action':
          return (
            <Stack
              horizontal
              verticalAlign="center"
              horizontalAlign="center"
              tokens={{ childrenGap: 3 }}
            >
              <EditAccessGroup accessGroup={item} />
            </Stack>
          );
        case 'accessGroupItems':
          return (
            <Stack wrap horizontal tokens={{ childrenGap: 10 }}>
              {item.accessGroupItems.nodes.map((groupItem, index) => (
                <Stack key={index}>
                  <AccessGroupItem item={groupItem} />
                </Stack>
              ))}
            </Stack>
          );
        default:
          return (
            <Stack
              verticalAlign="center"
              className={styles.onRenderColumnStack}
            >
              <Text>{fieldContent}</Text>
            </Stack>
          );
      }
    }
  };
  return renderItemColumn;
};
